  import { useMemo, useState } from "react";
import { createPortal } from "react-dom";
import { formatPrice } from "../utils/formatPrice";




const Navbar = ({
  cartCount = 0,
  cartProducts = [],
  cartTotal = 0,
  products = [],
  wishlistProducts = [],
  onAddToCart,
  onDecreaseCartItem,
  onRemoveCartItem,
  onOpenDetails,
  openLogin,
  openAccount,
  currentUser,
  onLogout,
}) => {
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isCheckoutOpen, setIsCheckoutOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [checkoutDetails, setCheckoutDetails] = useState({
    name: "",
    phone: "",
    address: "",
    paymentMethod: "razorpay",
  });

  const toggleMenu = () => {
    setIsMenuOpen((currentValue) => !currentValue);
    setIsSearchOpen(false);
    setIsCartOpen(false);
    setIsProfileOpen(false);
  };

  const searchResults = useMemo(() => {
    const query = searchQuery.trim().toLowerCase();

    if (!query) {
      return products;
    }

    return products.filter((product) =>
      `${product.name} ${product.category}`.toLowerCase().includes(query)
    );
  }, [products, searchQuery]);

  const closeMenus = () => {
    setIsSearchOpen(false);
    setIsCartOpen(false);
    setIsProfileOpen(false);
    setIsMenuOpen(false);
  };

  const updateCheckoutDetails = (event) => {
    const { name, value } = event.target;

    setCheckoutDetails((currentDetails) => ({
      ...currentDetails,
      [name]: value,
    }));
  };

  const handlePlaceOrder = () => {
    if (!currentUser) {
      openLogin("login");
      return;
    }

    if (!cartTotal) {
      alert("Your cart is empty.");
      return;
    }

    if (!checkoutDetails.name || !checkoutDetails.phone || !checkoutDetails.address) {
      alert("Please fill your delivery details.");
      return;
    }

    if (!window.Razorpay) {
      alert("Razorpay checkout is still loading. Please try again.");
      return;
    }

    const razorpayKey = process.env.REACT_APP_RAZORPAY_KEY_ID;

    if (!razorpayKey) {
      alert("Please add REACT_APP_RAZORPAY_KEY_ID in your .env file.");
      return;
    }

    const razorpay = new window.Razorpay({
      key: razorpayKey,
      amount: Math.round(cartTotal * 100),
      currency: "INR",
      name: "VEDA GLOW",
      description: `${cartCount} item skincare order`,
      image: "/veda-glow-mark.svg",
      prefill: {
        name: checkoutDetails.name,
        contact: checkoutDetails.phone,
        email: currentUser?.email || "",
      },
      notes: {
        address: checkoutDetails.address,
      },
      theme: {
        color: "#2D7A5A",
      },
      handler: () => {
        alert("Payment successful. Your order has been placed.");
        setIsCheckoutOpen(false);
        setIsCartOpen(false);
      },
      modal: {
        ondismiss: () => {
          alert("Payment cancelled.");
        },
      },
    });

    razorpay.open();
  };

  return (
    <nav className="site-nav">
      <div className="nav-inner">
        <div className="nav-brand-row">
          <a className="brand" href="#/" onClick={closeMenus} aria-label="Veda Glow home">
            <img className="brand-logo" src="/veda-glow-logo.svg" alt="Veda Glow" />
          </a>
          <button
            className={`nav-icon-btn nav-menu-toggle ${isMenuOpen ? "active" : ""}`}
            aria-label="Toggle navigation menu"
            aria-expanded={isMenuOpen}
            type="button"
            onClick={toggleMenu}
          >
            <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M4 7h16" />
              <path d="M4 12h16" />
              <path d="M4 17h16" />
            </svg>
          </button>
        </div>

        <ul className={`nav-links ${isMenuOpen ? "is-open" : ""}`}>
          <li><a href="#/" onClick={closeMenus}>Home</a></li>
           <li><a href="#/about" onClick={closeMenus}>About</a></li>
          <li><a href="#/shop" onClick={closeMenus}>Shop</a></li>
          <li><a href="#/blog" onClick={closeMenus}>Blog</a></li>
          <li><a href="#/contact" onClick={closeMenus}>Contact</a></li>
        </ul>

        <div className="nav-actions">
          <div className="search-menu-wrap">
            <button
              className="nav-icon-btn"
              aria-label="Search"
              aria-expanded={isSearchOpen}
              type="button"
              onClick={() => {
                setIsSearchOpen((currentValue) => !currentValue);
                setIsCartOpen(false);
                setIsProfileOpen(false);
                setIsMenuOpen(false);
              }}
            >
              <svg viewBox="0 0 24 24" width="21" height="21" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="11" cy="11" r="7" />
                <path d="M20 20l-3.5-3.5" />
              </svg>
            </button>

            {isSearchOpen && (
              <div className="search-popup" role="dialog" aria-label="Product search">
                <label className="search-field">
                  <span>Search products</span>
                  <input
                    type="search"
                    value={searchQuery}
                    placeholder="Search serum, sunscreen..."
                    autoFocus
                    onChange={(event) => setSearchQuery(event.target.value)}
                  />
                </label>

                <div className="search-results">
                  {searchResults.length > 0 ? (
                    searchResults.map((product) => (
                      <div className="search-result-item" key={product.id}>
                        <button type="button" onClick={() => onOpenDetails(product)}>
                          <img src={product.image} alt={product.name} />
                        </button>
                        <div>
                          <h3>{product.name}</h3>
                          <p>{product.category}</p>
                        </div>
                        <div className="search-result-actions">
                          <strong>{formatPrice(product.price)}</strong>
                          <button type="button" onClick={() => onAddToCart(product)}>Add</button>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p className="empty-cart-text">No products found</p>
                  )}
                </div>
              </div>
            )}
          </div>
              <div className="cart-menu-wrap">
            <button
              className="nav-icon-btn cart-action"
              aria-label={`Cart with ${cartCount} items`}
              aria-expanded={isCartOpen}
              type="button"
              onClick={() => {
                setIsCartOpen((currentValue) => !currentValue);
                setIsSearchOpen(false);
                setIsProfileOpen(false);
                setIsMenuOpen(false);
              }}
            >
              <svg viewBox="0 0 24 24" width="21" height="21" fill="none" stroke="currentColor" strokeWidth="2">



                <path d="M6 7h12l-1 13H7L6 7z" />
                <path d="M9 7a3 3 0 016 0" />
              </svg>
              {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
            </button>

            {isCartOpen && (
              <div className="cart-popup" role="dialog" aria-label="Cart details">
                <div className="cart-popup-header">
                  <h2>Your Cart</h2>
                  <span>{cartCount} items</span>
                </div>

                {cartProducts.length > 0 ? (
                  <>
                    <div className="cart-items">
                      {cartProducts.map((product) => (
                        <div className="cart-item" key={product.id}>
                          <img src={product.image} alt={product.name} />
                          <div>
                            <h3>{product.name}</h3>
                            <p>
                              {formatPrice(product.price)} x {product.quantity}
                            </p>
                            <div className="cart-qty-controls">
                              <button type="button" aria-label={`Decrease ${product.name}`} onClick={() => onDecreaseCartItem(product.id)}>-</button>
                              <span>{product.quantity}</span>
                              <button type="button" aria-label={`Increase ${product.name}`} onClick={() => onAddToCart(product)}>+</button>
                              <button type="button" onClick={() => onRemoveCartItem(product.id)}>Remove</button>
                            </div>
                          </div>
                          <strong>{formatPrice(product.price * product.quantity)}</strong>
                        </div>
                      ))}
                    </div>

                    <div className="cart-total-row">
                      <span>Billing Total</span>
                      <strong>{formatPrice(cartTotal)}</strong>
                    </div>

                    <button
                      className="checkout-btn"
                      type="button"
                      onClick={() => {
                        if (!currentUser) {
                          openLogin("login");
                          return;
                        }

                        setIsCheckoutOpen(true);
                      }}
                    >
                      Checkout
                    </button>
                  </>
                ) : (
                  <p className="empty-cart-text">Cart is empty</p>
                )}
              </div>
            )}
          </div>
          <div className="profile-menu-wrap">
            <button
              className="nav-icon-btn"
              aria-label="Profile"
              aria-expanded={isProfileOpen}
              type="button"
              onClick={() => {
                setIsProfileOpen((currentValue) => !currentValue);
                setIsSearchOpen(false);
                setIsCartOpen(false);
                setIsMenuOpen(false);
              }}
            >
              <svg viewBox="0 0 24 24" width="21" height="21" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="8" r="4" />
                <path d="M4 21a8 8 0 0116 0" />
              </svg>
            </button>

            {isProfileOpen && (
              <div className="profile-popup" role="dialog" aria-label="Profile options">
                {currentUser ? (
                  <>
                    <div className="profile-popup-header">
                      <h2>My Account</h2>
                      <p>{currentUser.email}</p>
                    </div>
                    <button
                      className="profile-primary-btn"
                      type="button"
                      onClick={() => {
                        setIsProfileOpen(false);
                        openAccount();
                      }}
                    >
                      Open Dashboard
                    </button>
                    <button
                      className="profile-secondary-btn"
                      type="button"
                      onClick={onLogout}
                    >
                      Logout
                    </button>
                  </>
                ) : (
                  <>
                    <div className="profile-popup-header">
                      <h2>Welcome</h2>
                      <p>Sign in to manage orders, wishlist, and skincare preferences.</p>
                    </div>
                    <button
                      className="profile-primary-btn"
                      type="button"
                      onClick={() => {
                        setIsProfileOpen(false);
                        openLogin("login");
                      }}
                    >
                      Login
                    </button>
                    <button
                      className="profile-secondary-btn"
                      type="button"
                      onClick={() => {
                        setIsProfileOpen(false);
                        openLogin("signup");
                      }}
                    >
                      Create Account
                    </button>
                  </>
                )}
                <div className="profile-links">
                  <button type="button">My Orders</button>
                  <button type="button">Wishlist</button>
                  <button type="button">Help Center</button>
                </div>

                <div className="wishlist-preview">
                  <h3>Wishlist</h3>
                  {wishlistProducts.length > 0 ? (
                    wishlistProducts.map((product) => (
                      <button key={product.id} type="button" onClick={() => onOpenDetails(product)}>
                        <span>{product.name}</span>
                        <strong>{formatPrice(product.price)}</strong>
                      </button>
                    ))
                  ) : (
                    <p>No wishlist items yet</p>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {isCheckoutOpen && createPortal(
        <div className="modal-backdrop" role="dialog" aria-label="Checkout form">
          <div className="checkout-modal">
            <div className="modal-heading">
              <div>
                <p>Secure checkout</p>
                <h2>Delivery Details</h2>
              </div>
              <button type="button" aria-label="Close checkout" onClick={() => setIsCheckoutOpen(false)}>x</button>
            </div>

            <form className="checkout-form">
              <input
                aria-label="Full name"
                name="name"
                onChange={updateCheckoutDetails}
                placeholder="Full name"
                value={checkoutDetails.name}
              />
              <input
                aria-label="Phone number"
                name="phone"
                onChange={updateCheckoutDetails}
                placeholder="Phone number"
                type="tel"
                value={checkoutDetails.phone}
              />
              <textarea
                aria-label="Full address"
                name="address"
                onChange={updateCheckoutDetails}
                placeholder="Full address"
                value={checkoutDetails.address}
              />
              <select
                aria-label="Payment method"
                name="paymentMethod"
                onChange={updateCheckoutDetails}
                value={checkoutDetails.paymentMethod}
              >
                <option value="razorpay">Pay Online - Razorpay</option>
              </select>
            </form>

            <div className="cart-total-row">
              <span>Payable Amount</span>
              <strong>{formatPrice(cartTotal)}</strong>
            </div>

            <button className="checkout-btn" type="button" onClick={handlePlaceOrder}>Place Order</button>
          </div>
        </div>,
        document.body
      )}
    </nav>
  );
};

export default Navbar;
